import React from "react";
import { TextField, Button } from "react-md";
import { Row, Col } from "react-flexbox-grid";

import homeIcon from "../../../../../../../../assets/icons/home-selected.png";
import officeIcon from "../../../../../../../../assets/icons/address-office-icon.svg";
import locationIcon from "../../../../../../../../assets/icons/address-others-icon.svg";

/* ✅ MOVE OUTSIDE */
const Field = ({
  label,
  required,
  value,
  onChange,
  placeholder = "Type here",
  disabled = false,
}) => (
  <div className="mp-plan-create-service-field-container">
    <div className="mp-plan-label">
      {label}
      {required && <label className="account-module-label-red">*</label>}
    </div>
    <TextField
      value={value || ""}
      lineDirection="left"
      placeholder={placeholder}
      onChange={onChange}
      disabled={disabled}
    />
  </div>
);

export default function AddressForm({
  data,
  onChange,
  onSubmit,
  onChangeLocation,
  onHide,
  googleAddress,
}) {
  const handleChange = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  return (
    <>
      <style>
        {`
          .mp-plan-create-service-field-container {
            display: flex;
            flex-direction: column;
            margin-bottom: 14px;
          }

          .mp-plan-label {
            color: #666666;
            font-family: Montserrat, sans-serif;
            font-size: 12px;
            margin-bottom: 4px;
          }

          .account-module-label-red {
            color: red;
            margin-left: 2px;
          }

          .address-type-option {
            display: flex;
            align-items: center;
            gap: 6px;
            padding: 8px 16px;
            border: 1px solid #D9D9D9;
            border-radius: 8px;
            cursor: pointer;
            font-size: 14px;
            font-family: Montserrat, sans-serif;
            background: #fff;
            transition: all 0.2s ease;
          }

          .address-type-option.selected {
            border-color: #6A5FF5;
            background: #F0EFFE;
          }
        `}
      </style>

      <div>
        {/* Header */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h3 style={{ margin: 0 }}>Search location</h3>
          <div style={{ textAlign: "right" }}>
            <Button
              className={"zy-btn-orange-1"}
              onClick={() => {
                onSubmit();
              }}
              raised
            >
              Save
            </Button>
            <Button
              onClick={() => {
                onHide();
              }}
              className="zy-btn-cancel-1"
            >
              Cancel
            </Button>
          </div>
        </div>

        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            background: "#f4f4f4",

            padding: "10px",
            border: "1px solid #D9D9D9",
            borderRadius: 12,

            marginTop: 16,
            marginBottom: 16,
          }}
        >
          <div>
            <div style={{ fontSize: 12, color: "#777", marginBottom: 6 }}>
              Location
            </div>
            <div
              style={{
                fontSize: 14,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {data?.coordinates?.latitude &&
              data?.coordinates?.longitude &&
              data.coordinates.latitude !== 0 &&
              data.coordinates.longitude !== 0 ? (
                <>
                  {googleAddress?.line1 ? `${googleAddress.line1}` : ""}
                  {googleAddress?.line2 ? `, ${googleAddress.line2}` : ""}
                  {googleAddress?.city ? `, ${googleAddress.city}` : ""}
                  {googleAddress?.state ? `, ${googleAddress.state}` : ""}
                  {googleAddress?.pincode ? ` - ${googleAddress.pincode}` : ""}
                </>
              ) : (
                <span style={{ color: "#666" }}>
                  Click on change button to update geo location
                </span>
              )}
            </div>
          </div>
          <Button raised primary onClick={onChangeLocation}>
            Change
          </Button>
        </div>

        <Row>
          <Col xs={12} sm={6}>
            <Field
              label="Full name"
              required
              value={data?.name}
              onChange={(v) => handleChange("name", v)}
            />
          </Col>

          <Col xs={12} sm={6}>
            <Field
              label="Mobile number"
              required
              value={data?.phoneNo}
              onChange={(v) => {
                const numeric = v.replace(/\D/g, "");

                if (numeric.length <= 10) {
                  handleChange("phoneNo", numeric);
                }
              }}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              label="House No. / Floor / Building"
              required
              value={data?.line1}
              onChange={(v) => handleChange("line1", v)}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              label="Colony / Street / Area"
              required
              value={data?.line2}
              onChange={(v) => handleChange("line2", v)}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12}>
            <Field
              label="Landmark"
              value={data?.landmark}
              onChange={(v) => handleChange("landmark", v)}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={6}>
            <Field
              label="Pincode"
              required
              value={data?.pincode}
              onChange={(v) => {
                const numeric = v.replace(/\D/g, "");
                if (numeric.length <= 6) {
                  handleChange("pincode", numeric);
                }
              }}
            />
          </Col>

          <Col xs={12} sm={6}>
            <Field
              label="City"
              required
              value={data?.city}
              onChange={(v) => handleChange("city", v)}
              disabled={!!data?.city && !!googleAddress?.city}
            />
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={6}>
            <Field
              label="District"
              required
              value={data?.district}
              onChange={(v) => handleChange("district", v)}
              disabled={!!data?.district && !!googleAddress?.district}
            />
          </Col>

          <Col xs={12} sm={6}>
            <Field
              label="State"
              required
              value={data?.state}
              onChange={(v) => handleChange("state", v)}
              disabled={!!data?.state && !!googleAddress?.state}
            />
          </Col>
        </Row>

        <div style={{ marginBottom: 14 }}>
          <div className="mp-plan-label">
            Address type
            <label className="account-module-label-red">*</label>
          </div>
          <div style={{ display: "flex", gap: 12, marginTop: 6 }}>
            {[
              { value: "Home", icon: homeIcon, label: "Home" },
              { value: "Work", icon: officeIcon, label: "Work" },
              { value: "Other", icon: locationIcon, label: "Other" },
            ].map((opt) => (
              <div
                key={opt.value}
                className={`address-type-option${
                  data?.type === opt.value ? " selected" : ""
                }`}
                onClick={() => handleChange("type", opt.value)}
              >
                <img
                  src={opt.icon}
                  alt={opt.label}
                  style={{ width: 18, height: 18 }}
                />
                {opt.label}
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}
